import axios from 'axios'
import {AppConfigModel} from '../../../models/app-config/AppConfigModel'

export const GetAppConfig = () => axios.get<AppConfigModel[]>('/config-group/app')
